import { ListGroup } from 'react-bootstrap';
import { ModerationGroupQuery } from '../../../generated/graphql';
import React from 'react';
import { StatusBadge } from '../../../components';
import routes from '../../../routes/routes';
import { useHistory } from 'react-router-dom';

type Users = NonNullable<ModerationGroupQuery['group']>['users'];

interface UsersListProps {
    usersList: Users;
    title: string;
}

export const UsersList: React.FC<UsersListProps> = ({ usersList, title }) => {
    const history = useHistory();

    return (
        <>
            <h4 style={{ marginTop: 50 }}>{title}</h4>
            {!usersList?.length && <div style={{ margin: 'auto' }}>Немає користувачів з даним статусом</div>}
            {usersList?.map((childrenItem) => {
                return (
                    <ListGroup.Item
                        key={childrenItem.id}
                        onClick={() => history.push(`${routes.user}/${childrenItem.id}`)}
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        {childrenItem.name} {childrenItem.moderator ? '(Модератор)' : ''}
                        <div style={{ flexDirection: 'column', display: 'flex' }}>
                            <div>
                                <StatusBadge status={0} />:{childrenItem.statuses.status0}
                            </div>
                            <div>
                                <StatusBadge status={1} />:{childrenItem.statuses.status1}
                            </div>
                            <div>
                                <StatusBadge status={2} />:{childrenItem.statuses.status2}
                            </div>
                            <div>
                                <StatusBadge status={3} />:{childrenItem.statuses.status3}
                            </div>
                        </div>
                    </ListGroup.Item>
                );
            })}
        </>
    );
};
